import { useState } from "react";
import { companionRuntimeApiBase } from "../apiBase";
import { COMPANION_PRODUCT, NANODE_SYNC_HINT_URL } from "../companion";
import type { CompanionApi } from "../useCompanion";

export function AuthGate({ api }: { api: CompanionApi }) {
  const [email, setEmail] = useState(api.account?.email ?? "");
  const [password, setPassword] = useState("");
  const [baseUrl, setBaseUrl] = useState(api.account?.baseUrl || api.settings.baseUrl || "");
  const [token, setToken] = useState(api.settings.token || "");

  return (
    <div className="more-stack" data-testid="auth-gate">
      <img className="auth-logo" src="/icons/icon.svg" width={64} height={64} alt="" />
      <p className="kicker" data-testid="pilot-logon">Pilot logon</p>
      <h1>{COMPANION_PRODUCT}</h1>
      <p className="muted">
        Same Nanode email and password as the desk. This phone opens as the pilot. Fleet and trips stay
        on the desk board.
      </p>
      <form className="panel bevel-out" onSubmit={(e) => e.preventDefault()}>
        {api.hosted ? null : (
          <div className="field">
            <label htmlFor="gate-url">Sync server</label>
            <input
              id="gate-url"
              value={baseUrl}
              placeholder={NANODE_SYNC_HINT_URL}
              onChange={(e) => setBaseUrl(e.target.value)}
            />
          </div>
        )}
        <div className="field">
          <label htmlFor="gate-email">Email</label>
          <input
            id="gate-email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {api.hosted ? null : (
          <div className="field">
            <label htmlFor="gate-token">Company token</label>
            <input
              id="gate-token"
              type="password"
              autoComplete="off"
              value={token}
              onChange={(e) => setToken(e.target.value)}
            />
          </div>
        )}
        <div className="field">
          <label htmlFor="gate-pass">Password</label>
          <input
            id="gate-pass"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="row">
          <button
            type="button"
            className="btn"
            disabled={api.busy}
            onClick={() =>
              void api.signIn({
                email,
                password,
                baseUrl: api.hosted ? api.settings.baseUrl || companionRuntimeApiBase() : baseUrl,
                token: api.hosted ? undefined : token,
              })
            }
          >
            Sign in
          </button>
        </div>
      </form>
      {api.note ? <p className="ok">{api.note}</p> : null}
      {api.error ? <p className="err">{api.error}</p> : null}
    </div>
  );
}
